import React from 'react';
import styled from '@emotion/styled';
import urLogo from '../assets/ur-logo.png';

const FooterContainer = styled.footer`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
`;

const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const URLogoImage = styled.img`
  height: 40px;
  width: auto;
`;

const URCodeText = styled.span`
  color: white;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: 1px;
`;

export const URCodeFooter: React.FC = () => {
  return (
    <FooterContainer>
      <LogoWrapper>
        <URLogoImage src={urLogo} alt="UR Logo" />
        <URCodeText>URCODE</URCodeText>
      </LogoWrapper>
    </FooterContainer>
  );
};

export default URCodeFooter;
